import { render, staticRenderFns } from "./MyMain.vue?vue&type=template&id=59aa1fa8&scoped=true"
import script from "./MyMain.vue?vue&type=script&lang=js"
export * from "./MyMain.vue?vue&type=script&lang=js"
import style0 from "./MyMain.vue?vue&type=style&index=0&id=59aa1fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa1fa8",
  null
  
)

export default component.exports